import crown from "@/assets/crown.png";

const BG =
  "https://images.unsplash.com/photo-1721140176073-79284deadd94?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export const ComingSoon = () => (
  <div
    className="fixed inset-0 z-50 flex items-center justify-center bg-[#0B0B0F]"
    data-testid="coming-soon-screen"
  >
    <img
      src={BG}
      alt=""
      className="absolute inset-0 w-full h-full object-cover opacity-25"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-[#0B0B0F] via-[#0B0B0F]/70 to-[#0B0B0F]/40" />
    <div className="relative z-10 flex flex-col items-center text-center px-8 max-w-md fade-up">
      <img src={crown} alt="" className="w-20 h-20 crown-glow mb-8" />
      <p className="text-[#D4AF37] text-xs tracking-[0.4em] uppercase mb-4 font-medium">
        Coming Soon
      </p>
      <h1 className="font-serif text-4xl sm:text-5xl text-white font-semibold tracking-tight mb-6">
        THE CIRCLE
      </h1>
      <div className="gold-divider w-24 mb-6" />
      <p className="text-[#E0E0E0] text-base leading-relaxed">
        THE CIRCLE is currently exclusive to{" "}
        <span className="text-[#D4AF37] font-semibold">Kolkata</span>.
      </p>
      <p className="text-[#A0A0A0] text-sm mt-3 leading-relaxed">
        We are curating tables city by city. Yours is next.
      </p>
    </div>
  </div>
);
